import { render } from "./nuevoPedidoSubAgente.vue?vue&type=template&id=5f7890ee&scoped=true"
import script from "./nuevoPedidoSubAgente.vue?vue&type=script&lang=js"
export * from "./nuevoPedidoSubAgente.vue?vue&type=script&lang=js"

import "./nuevoPedidoSubAgente.vue?vue&type=style&index=0&id=5f7890ee&scoped=true&lang=css"
import "./nuevoPedidoSubAgente.vue?vue&type=style&index=1&id=5f7890ee&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f7890ee"]])

export default __exports__